<template>
    <div>
      <div v-if="type === 'nominale'">
        <form-field-km v-model="kmValue" :km="km" :km_placeholder="km_placeholder"></form-field-km>
        <form-field-property></form-field-property>
        <car-notes :notes="notes"></car-notes>
        <form-field-average
        :kmMensili="kmMensili"
        :cap="cap"
        @update:kmMensili="kmMensiliValue = $event"
        @update:cap="capValue = $event"
        ></form-field-average>
      </div>
      <div v-else-if="type === 'live-market'">
        <form-field-km v-model="kmValue" :km="km" :km_placeholder="km_placeholder"></form-field-km>
        <form-field-average
        :kmMensili="kmMensili"
        :cap="cap"
        @update:kmMensili="kmMensiliValue = $event"
        @update:cap="capValue = $event"
        ></form-field-average>
        <car-notes :notes="notes"></car-notes>
        <form-field-property></form-field-property>
      </div>
      <div v-else-if="type === 'storica'">
        <form-field-date :anni="anni" :mesi="mesi" @validation="updateDateValidation"></form-field-date>
        <form-field-add-info></form-field-add-info>
      </div>
      <div v-else-if="type === 'sponsor'">
        <form-field-km v-model="kmValue" :km="km" :km_placeholder="km_placeholder"></form-field-km>
        <form-field-property></form-field-property>
        <car-notes :notes="notes"></car-notes>
      </div>
    </div>
  </template>

  <script>
  import FormFieldKm from './FormFieldKm.vue';
  import FormFieldAverage from './FormFieldAverage.vue';
  import FormFieldDate from './FormFieldDate.vue';
  import FormFieldAddInfo from './FormFieldAddInfo.vue';
  import FormFieldProperty from './FormFieldProperty.vue';
  import CarNotes from './CarNotes.vue';

  export default {
    name: 'FormFields',
    components: {
      FormFieldKm,
      FormFieldAverage,
      FormFieldDate,
      FormFieldAddInfo,
      FormFieldProperty,
      CarNotes,
    },
    props: {
      type: {
        type: String,
        required: true,
      },
      km: {
        type: Number,
        required: false,
      },
      km_placeholder: {
        type: Number,
        required: false,
      },
      kmMensili: {
        type: Number,
        required: false,
      },
      cap: {
        type: String,
        required: false,
      },
      notes: {
        type: Object,
        required: false,
      },
      anni: {
        type: Object,
        required: false,
      },
      mesi: {
        type: Object,
        required: false,
      },
    },
    data() {
        return {
          kmValue: this.km,
          kmMensiliValue: this.kmMensili,
          capValue: '',
          isDateValid: false,
        };
    },
    watch: {
        km(newVal) {
            this.kmValue = newVal;
        },
        kmValue(newVal) {
            this.$emit('update:km', newVal);
        },
    },
    methods: {
        updateDateValidation(isValid) {
            this.isDateValid = isValid;
            this.$emit('date-validation', isValid);
        },
    },
  };
  </script>



// WEBPACK FOOTER //
// resources/js/app/components/FormFields.vue